import React from 'react';
import DevelopmentInProgress from '../../../../components/common/DevelopmentInProgress';

export default function GeneralPaymentRecieved({ form, setForm, error, setError }) {
	return <DevelopmentInProgress />;
}
